import commentButtons from './comment-buttons';
import commentOptions from './comment-options';
import commentDeletes from './comment-deletes';
import commentEdits from './comment-edits';
import commentsShowMore from './comments-show-more';

const fn = {
  classCommentHide: 'card__comments--hide',
  init: () => {
    const comments = document.querySelectorAll('.js-comments');

    if (!comments.length) {
      return;
    }

    fn.hideComments(comments);

    commentOptions.init();
    commentButtons.init();
    commentDeletes.init();
    commentEdits.init();
    commentsShowMore.init();
  },
  hideComments(comments) {
    [].forEach.call(comments, (commentItems) => {
      commentItems.classList.add(fn.classCommentHide);
    });
  },
};

export default fn;
